import { Form, Input, Button } from 'antd';
import { toast } from 'react-toastify';
import type { User } from 'types/user';
import { API_URL } from 'env';

export interface UserEditContentProps {
    user: User;
    triggerUpdate?: () => void;
    onCancel: () => void;
}

interface FormValues {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
}

const UserEditContent = ({ user, onCancel, triggerUpdate }: UserEditContentProps) => {
    const [form] = Form.useForm<FormValues>();

    const onSave = async (values: FormValues) => {
        try {
            const res = await fetch(`${API_URL}api/v1/be/user/${user.id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                },
                body: JSON.stringify({
                    first_name: values.firstName,
                    last_name: values.lastName,
                    email: values.email,
                    phone: values.phone,
                }),
            });
            if (!res.ok) throw new Error();
            toast.success('Cập nhật thành công');
            triggerUpdate?.();
            onCancel();
        } catch {
            toast.error('Cập nhật thất bại. Vui lòng thử lại.');
        }
    };

    return (
        <div className="p-4">
            <Form
                form={form}
                layout="vertical"
                initialValues={{
                    firstName: user.firstName || '',
                    lastName: user.lastName || '',
                    email: user.email,
                    phone: user.phonenumber || '',
                }}
                onFinish={onSave}
            >
                <div className="grid grid-cols-2 gap-x-4">
                    <Form.Item name="firstName" label="First Name">
                        <Input placeholder="Enter first name" />
                    </Form.Item>
                    <Form.Item name="lastName" label="Last Name">
                        <Input placeholder="Enter last name" />
                    </Form.Item>
                </div>
                <Form.Item
                    name="email"
                    label="Email"
                    rules={[{ type: 'email', message: 'Email không hợp lệ' }]}
                >
                    <Input placeholder="Enter email" />
                </Form.Item>
                <Form.Item name="phone" label="Phone Number">
                    <Input placeholder="Enter phone number" />
                </Form.Item>
                <div className="flex gap-2 justify-end">
                    <Button onClick={onCancel}>Hủy</Button>
                    <Button type="primary" htmlType="submit">Lưu</Button>
                </div>
            </Form>
        </div>
    );
};

export default UserEditContent;
